import React, { useContext, useState } from "react";
import { ExchangeFromTable as Table, UnderlineLinkComponent } from "./styles";
import { ColumnTitleMobile, ColumnValue, ButtonLoader, UnderlyingContent } from "../../styles";
import moment from "moment";
import {
    Frequency as FrequencyTypeConstants,
    DateFormat,
    NoEditSpawnStatuses,
    ViewSpawnOnStatuses
} from '../../constants';
import { SecondaryButtonComponent } from "../../../../../../CommonComponents/commonStyles";
import {
    cancelSingleSpawn,
    reverseSingleSpawn
} from '../../../../../../services/apiServices';
import Context from "../../context";
import loaderIcon from "../../../../../../assets/icons/loader.gif";
import { AlertMessagePrimary } from '../popup/index';
import { checkCSRBusinessFunction } from "../../../../../../CSR/utils/CommonUtils";
import { BUSINESS_FUNCTION } from '../../../../../../CSR/utils/csrBusinessFunctionMapper';
import { initiateTracking, recordError } from "../../../../../../utils/commonUtil";
import { AlertContent, Types } from "../../../../../../CommonComponents/ContentMessages";

function SpawnTable(props) {
    const { dataSource, isViewEdit, userId, exchScheduleId, history, refreshExchangeDetails, persistContext, edit, isBalanceZero, cancellingReversingSpawn, csrBusinessFunction,isAllShareAllPoolExist } = props;
    const { exchangeContext, setExchangeContext } = useContext(Context);
    const [cancelSpawnPopUp, handleCancelSpawnPopUp] = useState(false);
    const [selectedSpawn, setSelectedSpawn] = useState({});

    const viewSpawnDetails = (orderId) => {
        try {
            history.push(`/investments/recommend-an-exchange/${orderId}/view?type=onetime`);
        } catch (error) {
            recordError(error);
        }
    }

    const columns = [
        {
            title: "Exchanges",
            className: "investment-pool-title hide-col-title-in-mobile",
            dataIndex: "exchanges",
            key: "exchanges",
        },
        {
            title: "Next schedule date",
            className: "hide-col-title-in-mobile cell-w100",
            dataIndex: "nextScheduleDate",
            key: "nextScheduleDate",
            render: (text) => {
                return <>
                    <ColumnTitleMobile>Next schedule date</ColumnTitleMobile>
                    <ColumnValue>{text}</ColumnValue>
                </>
            }
        }
    ];

    let editColumn = [
        {
            title: "Exchanges",
            className: "investment-pool-title hide-col-title-in-mobile",
            dataIndex: "exchanges",
            key: "exchanges",
            width: "20%",
            render: (text, record) => {
                return <>
                    {ViewSpawnOnStatuses.includes(record.status.toLowerCase()) ? <UnderlyingContent data-test="viewSpawnDetails" onClick={()=>viewSpawnDetails(record.orderId)}>{text}</UnderlyingContent>: <>{text}</>}
                </>
            }
        },
        {
            title: "Next schedule date",
            className: "hide-col-title-in-mobile",
            dataIndex: "nextScheduleDate",
            key: "nextScheduleDate",
            width: "20%",
            render: (text) => {
                return <>
                    <ColumnTitleMobile>Next schedule date</ColumnTitleMobile>
                    <ColumnValue>{text}</ColumnValue>
                </>
            }
        },
        {
            title: "Status",
            className: "hide-col-title-in-mobile",
            dataIndex: "status",
            key: "status",
            width: "20%",
            render: (text) => {
                return <>
                    <ColumnTitleMobile>Status</ColumnTitleMobile>
                    <ColumnValue>{text}</ColumnValue>
                </>
            }
        },
    ];

    if (edit) {
        if (!isBalanceZero && !isAllShareAllPoolExist) {
            editColumn.push({
                title: '',
                className: "hide-col-title-in-mobile",
                dataIndex: "edit",
                key: "edit",
                width: "10%"
            });
        }
        editColumn.push({
            title: '',
            className: "hide-col-title-in-mobile",
            dataIndex: "cancel",
            key: "cancel",
            width: "10%"
        });
    }

    const onCancelSpawn = (source) => {
        try {
            setSelectedSpawn(source);
            handleCancelSpawnPopUp(true);
        } catch (error) {
            recordError(error);
        }
    }

    const cancelSpawn = () => {
        const { exchPendingSpawnId } = selectedSpawn;
        cancellingReversingSpawn('cancelSpawn',exchPendingSpawnId);
        cancelSingleSpawn({ userId, exchScheduleId, exchPendingSpawnId }).then((res) => {
            // In case of confirmation we will not get refreshExchangeDetails
            initiateTracking('cancelTable', 'View and Edit Exchange', `Recommend exchange schedule - ${selectedSpawn.status}`, `Cancel - Recurring Exchange`);
            setSelectedSpawn({});
            handleCancelSpawnPopUp(false);
            refreshExchangeDetails && refreshExchangeDetails();
        })
    }

    const reverseSpawn = (source) => {
        try {
            const { exchPendingSpawnId } = source;
            cancellingReversingSpawn('reverseSpawn',exchPendingSpawnId);
            reverseSingleSpawn({ userId, exchScheduleId, exchPendingSpawnId }).then((res) => {
                // In case of confirmation we will not get refreshExchangeDetails
                initiateTracking('reverse', 'View and Edit Exchange', `Recommend exchange schedule - ${source.status}`, `Reverse - Recurring Exchange`);
                refreshExchangeDetails && refreshExchangeDetails();
            })
        } catch (error) {
          recordError(error);
        }
    }

    // Check the feature is avalilable by the particular csr user
    const checkCsrBusiness = businessFunction => {
        return checkCSRBusinessFunction(BUSINESS_FUNCTION[businessFunction], csrBusinessFunction);
    }

    const spawnsConfig = (dataSource, isViewEditLocal) => {
        let spawnsArr = [];
        if (dataSource) {
            if (isViewEditLocal) {
                spawnsArr = dataSource.map((source, index, array) => {
                    return {
                        orderId: source.orderId,
                        exchanges: `Exchange ${source.exchangeId}`,
                        nextScheduleDate: moment(source.exchangeDate).format(DateFormat),
                        status: source.status,
                        edit: <>{edit && source.status === 'Not scheduled' && !source.cancelling && <SecondaryButtonComponent data-test="btnEdit" id="btnEdit" onClick={() => {
                            try {
                                let spawn = 'spawn';
                                const tmp = { ...exchangeContext };
                                let startDate = source.enterDate
                                let endDate = null;
                                if (0 < index) {
                                    for(let i = index - 1; i >= 0; i--) {
                                        if(moment(array[i].exchangeDate).diff(moment()) < 0) {
                                            startDate = moment().format(DateFormat)
                                            break;
                                        } else if (array[i].status.toLowerCase() !== 'cancelled') {
                                            startDate = moment(array[i].exchangeDate, 'x').format(DateFormat);
                                            break;
                                        }
                                    }
                                }
                                if (index < array.length - 1) {
                                    for(let i = index + 1; i < array.length; i++) {
                                        if (array[i].status.toLowerCase() !== 'cancelled') {
                                            endDate = moment(array[i].exchangeDate, 'x').format(DateFormat)
                                            break;
                                        }
                                    }
                                }
    
                                tmp.spawnRange = {
                                    currentDate: moment(source.exchangeDate).format(DateFormat),
                                    startDate: startDate,
                                    endDate: endDate,
                                }
                                initiateTracking('edit', 'View and Edit Exchange', `Recommend exchange schedule - ${source.status}`, `Edit Table - Recurring Exchange`);
                                setExchangeContext(tmp);
                                persistContext && persistContext();
                                history && history.push({
                                    pathname: `/investments/recommend-an-exchange/${exchScheduleId}/spawn/${source.exchPendingSpawnId}/view`,
                                    search: `type=${spawn}`,
                                })
                            } catch (error) {
                              recordError(error);
                            }
                        }}>Edit</SecondaryButtonComponent>}
                        </>,
                        cancel: <>
                            {edit && !NoEditSpawnStatuses.includes(source.status.toLowerCase()) && source.status.toLowerCase() === 'not scheduled' && <UnderlineLinkComponent id="anrCancelSpawn" loading={source.cancelling} disabled={checkCsrBusiness('DONOR_PORTAL_EDIT_RECURRING_EXCHANGE_FULL_ACCESS')} onClick={() => onCancelSpawn(source)}>Cancel<ButtonLoader src={loaderIcon} alt='loader'/></UnderlineLinkComponent>}
                            {edit && NoEditSpawnStatuses.includes(source.status.toLowerCase()) && source.status.toLowerCase() === 'cancelled' && <UnderlineLinkComponent id="anrReverseSpawn" loading={source.reversing} disabled={checkCsrBusiness('DONOR_PORTAL_EDIT_RECURRING_EXCHANGE_FULL_ACCESS')} onClick={() => reverseSpawn(source)}>Reverse<ButtonLoader src={loaderIcon} alt='loader'/></UnderlineLinkComponent>}
                        </>,
                    }
                })
            } else {
                spawnsArr = dataSource.map((source, i) => {
                    return {
                        exchanges: `Exchange ${source.exchangeId}`,
                        nextScheduleDate: moment(source.exchangeDate).format(DateFormat)
                    }
                });
            }
        }
        return spawnsArr;
    }

    if(props.isPrintCheck){
        return props.printRender(isViewEdit ? editColumn : columns, spawnsConfig(dataSource, isViewEdit))
    }

    return (
        <div>
            <Table
                data-test="SpawnTable"
                pagination={false}
                columns={isViewEdit ? editColumn : columns}
                dataSource={spawnsConfig(dataSource, isViewEdit)}
            />
            <AlertMessagePrimary
                className ="altCancelSpawn" 
                visible={cancelSpawnPopUp}
                title={
                    <AlertContent
                        page={"Edit Exchange"}
                        type={[Types.PAGE_ALERTS]}
                        keyProperty={"Cancel Spawn"}
                        property={"field_header"}
                        defaultMessage={"Cancel"}
                    />
                }
                data-test="cancelSpawn"
                onOk={cancelSpawn}
                onCancel={() => handleCancelSpawnPopUp(false)}
                cancelText={
                    <AlertContent
                        page={"Edit Exchange"}
                        type={[Types.PAGE_ALERTS]}
                        keyProperty={"Cancel Spawn"}
                        property={"field_alert_button2_text"}
                        defaultMessage={"No, take me back"}
                        isButton={true}
                    />
                }
                okText={
                    <AlertContent
                        page={"Edit Exchange"}
                        type={[Types.PAGE_ALERTS]}
                        keyProperty={"Cancel Spawn"}
                        property={"field_alert_button1_text"}
                        defaultMessage={"CONTINUE"}
                        isButton={true}
                    />
                }
            >
                 <AlertContent
                    page={"Edit Exchange"}
                    type={[Types.PAGE_ALERTS]}
                    keyProperty={"Cancel Spawn"}
                    property={"field_description"}
                    html={true}
                    defaultMessage={"Are you sure you want to cancel this exchange?"}
                />
            </AlertMessagePrimary>
        </div>
    );
}

export default SpawnTable;
